import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { GlobalService } from '../services/global.service';
import { MLService } from '../services/ml-service';
import { moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { DataSrc, ModelParameter } from '../models/mlmodel/mlModel-parameters.model';
import { NgForm, UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { InputParameter } from '../models/mlmodel/inputParameters.model';
import { Model } from '../models/mlmodel/Model.model';
import { AlertComponent } from '../common/alert/alert.component';
import { ConfirmModelComponent } from '../common/confirm-model/confirm-model.component';
import { catchError, concatMap, flatMap, map, mergeMap, switchMap, tap } from 'rxjs/operators';
import { EMPTY, of } from 'rxjs';
import { ParameterModel } from '../models/mlmodel/parameter.model';

@Component({
  selector: 'app-data-source-manager',
  templateUrl: './data-source-manager.component.html',
  styleUrls: ['./data-source-manager.component.css']
})

export class DataSourceManagerComponent implements OnInit {
  @ViewChild('f', { static: true }) registerForm: NgForm;
  myFormGroup: UntypedFormGroup;
  inputParameters = [];
  outputParameters = [];
  modelVariablesList: InputParameter[] = [];
  deletedInputParam: InputParameter;
  srcConnVariablesList = [];
  modelData = new Model();
  dataToPass = [];
  nextStep = false;
  form_template = [];
  isLoading = false;
  dataSource: any[];
  dataSourceSelected;
  dataSourceName;
  parameterList: any[];
  selectedParameter;
  frequncy = 120;
  responseOutput = [];
  readOnly: false;
  runId: number = 0;
  simulationRunStatus = true;
  dataId;
  parameterModel = new ParameterModel();

  constructor(public dialogRef: MatDialogRef<DataSourceManagerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public globals: GlobalService,
    public mlService: MLService,
    public dialog: MatDialog) {
  };

  ngOnInit() {
    this.isLoading = true;
    this.dialogRef.disableClose = true;
    this.getModelParameters();
  }

  getModelParameters() {
    this.mlService.getConfigParameter(this.data.modelId).pipe(
      concatMap((data: any) => {
        this.addModel(this.modelData, data);
        this.outputParameters = data.outputParameters;
        this.inputParameters = JSON.parse(JSON.stringify(this.modelData.inputParameters));// to avoid value by reference
        //this.getDataSources();
        return of(data);
      }),
      concatMap((data) => {
        return of(this.getDataSources());
      })
    ).subscribe();
  }

  addModel(model: Model, responseData) {
    model.modelId = responseData.modelId;
    model.modelName = responseData.modelName;
    model.modelType = this.data.modelType;
    responseData.inputParameters.forEach((param) => {
      let inputParam = new InputParameter();
      inputParam.data = this.parseParameterData(param);
      model.inputParameters.push(inputParam);
    });
  }

  parseParameterData(param: any): ModelParameter {
    let parameter = new ModelParameter();
    parameter.parameterId = param.parameterId;
    parameter.parameterName = param.parameterName;
    parameter.parameterDataType = param.parameterDataType;
    parameter.parameterUom = param.parameterUom;
    parameter.captionName = param.captionName;
    return parameter;
  }


  getDataSources(): any {
    this.mlService.getDataSources().subscribe((data: any) => {
      this.dataSource = data;
      this.dataSourceSelected = this.dataSource[0];
      this.getDataSourceParameters();

    }, (error: Error) => {
      this.globals.showAlert(AlertComponent, { success: false, message: "Failed to load Data source!" });
      this.isLoading = false;
    });
  }

  getDataSourceParameters() {
    this.mlService.getDataSourceParameters(this.dataSourceSelected.dataSourceId).subscribe((data: any) => {
      this.parameterList = data;
      this.isLoading = false;
    }, (error: Error) => {
      this.globals.showAlert(AlertComponent, { success: false, message: "Failed to load data source parameters!" });
      this.isLoading = false;
    });
  }

  drop(event) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }
  }

  onCancelClick() {
    this.dialogRef.close(false);
  }

  deleteMapping(index) {
    this.srcConnVariablesList.splice(index, 1);
    if (this.modelVariablesList[index]) {
      this.deletedInputParam = this.modelVariablesList.splice(index, 1)[0];
      this.resetParameterSrcMapData(this.deletedInputParam);
      this.returnParameterToOriginalPosition(this.inputParameters, this.deletedInputParam);
    }
  }

  resetParameterSrcMapData(param: InputParameter) {
    param.mappedDataSource = DataSrc.user;
    param.mappedDataSourceId = '';
    param.mappedParameterId = 0;
    param.mappedParameterName = '';
    param.mappedFrequency = 0;
    param.mappedParameterUoM = '';
  }
  
  returnParameterToOriginalPosition(paramList, param) {
    let args = paramList
    .filter(p => p.parameterId < param.parameterId)
    .map(function (p) { return p.parameterId; });
        
    let prevIndex = Math.max(...args);
    prevIndex = prevIndex < 0 ? 0 : prevIndex;
    paramList.splice(prevIndex, 0, param);
  }

  onSelectParameter(parameter) {
    let srcParameterData = {
      mappedDataSource: DataSrc.extDataSrc,
      mappedDataSourceId: this.dataSourceSelected.dataSourceId,
      mappedFrequency: this.frequncy,
      mappedParameterId: parameter.srcParameterId,
      mappedParameterName: parameter.srcParameter,
      mappedParameterUoM: ''
    };
    this.srcConnVariablesList.push(srcParameterData);
    this.selectedParameter = undefined;
  }

  executeModel() {
    this.responseOutput = [];
    this.nextStep = true;
    let formItem = [];
    let group = {};
    for (let i = 0; i < this.inputParameters.length; i++) {
      if (this.inputParameters[i].mappedDataSource === DataSrc.user) {
        let obj = {};
        obj['inputModel'] = this.inputParameters[i].data.parameterName + "-" + this.inputParameters[i].data.parameterId;
        obj['label'] = this.inputParameters[i].data.captionName;
        obj['uom'] = this.inputParameters[i].data.parameterUom;
        obj['value'] = this.inputParameters[i].data.parameterDefaultValue;
        if (obj['value'] == null || typeof (this.inputParameters[i].data.parameterDefaultValue) === 'string') {
          obj['type'] = 'textBox';
        } else if (obj['value'] == null || typeof (this.inputParameters[i].data.parameterDefaultValue) === 'number') {
          obj['type'] = 'number';
        } else {
          obj['type'] = 'checkbox';
        }
        formItem.push(obj);
      }
    }
    this.form_template = formItem;
    this.form_template.forEach(input_template => {
      group[input_template.inputModel] = new UntypedFormControl(input_template.value);
    })
    this.myFormGroup = new UntypedFormGroup(group);
    if (this.inputParameters.length === 0) {
      this.executeModelNextLevel();
    }
  }

  gotoPrev() {
    this.nextStep = false;
  }

  onSubmit() {
    for (let [key, value] of Object.entries(this.myFormGroup.value)) {
      let res = key.split('-');

      this.parameterModel.model = this.modelData;
      this.parameterModel.parameterId = res[1]
      this.parameterModel.dataSource = DataSrc.user;
      this.parameterModel.dataSourceId = 1;
      this.parameterModel.srcFrequency = 0;
      this.parameterModel.srcParameterId = 0;
      this.parameterModel.srcParameterName = '';
      this.parameterModel.srcParameterUoM = '';
      this.parameterModel.defaultValue = value;
      this.updateParameterMapping(this.parameterModel);
    }
    this.executeModelNextLevel();
  }

  executeModelNextLevel() {
    this.isLoading = true;
    this.modelVariablesList.forEach((connParam, index) => {
      if (this.srcConnVariablesList.length > 0) {
        let srcParam = this.srcConnVariablesList[index];

        this.parameterModel.model = this.modelData;
        this.parameterModel.parameterId = connParam.data.parameterId
        this.parameterModel.dataSource = DataSrc.extDataSrc;
        this.parameterModel.dataSourceId = srcParam.mappedDataSourceId;
        this.parameterModel.srcFrequency = srcParam.mappedFrequency;
        this.parameterModel.srcParameterId = srcParam.mappedParameterId;
        this.parameterModel.srcParameterName = srcParam.mappedParameterName;
        this.parameterModel.srcParameterUoM = srcParam.mappedParameterUoM;
        this.parameterModel.defaultValue = connParam.data.parameterDefaultValue;
        this.updateParameterMapping(this.parameterModel);
      }
    });

    this.mlService.executeModel(this.modelData).subscribe((data: any): void => {
      if ((this.modelData.modelType).toLowerCase() == "surrogate" || (this.modelData.modelType).toLowerCase() == "physics based") {
        this.responseOutput = data;
        this.simulationRunStatus = true;
      }
      else if ((this.modelData.modelType).toLowerCase() == "simulation") {
        let dataToPass = {
          title: 'Run Smoke Test',
          isDelete: false,
          message: 'Smoke test for this Simulation model will take more time, would you like to continue?'
        };
        this.runId = data;
        this.globals.openModelWindow(this.simulationRunOnConfirm, this, ConfirmModelComponent, '450px', 'confirm-modalbox', dataToPass);
      }
      this.isLoading = false;
    }, (error: Error) => {
      this.globals.showAlert(AlertComponent, { success: false, message: "Failed to execute test!" });
      this.isLoading = false;
    });
  }

  simulationRunOnConfirm(thisRef: DataSourceManagerComponent) {
    thisRef.isLoading = false;
    thisRef.mlService.getSimulationRunReport(thisRef.runId).subscribe((data: any): void => {
      thisRef.simulationRunStatus = data.simulationRunStatus;
      thisRef.responseOutput = data.responseOutput;
    }, (error: Error) => {
      thisRef.globals.showAlert(AlertComponent, { success: false, message: "Something Went Wrong" });
    });
  }
  updateParameterMapping(parameterModel: ParameterModel) {
    let param = parameterModel.model.inputParameters.find(p => p.data.parameterId == parameterModel.parameterId);

    param.mappedDataSource = parameterModel.dataSource;
    param.mappedDataSourceId = parameterModel.dataSourceId;
    param.mappedFrequency = parameterModel.srcFrequency;
    param.mappedParameterId = parameterModel.srcParameterId;
    param.mappedParameterName = parameterModel.srcParameterName;
    param.mappedParameterUoM = parameterModel.srcParameterUoM;
    param.data.parameterDefaultValue = parameterModel.defaultValue;
  }

}
